import { useContext } from 'react';
import AlertContext from 'services/AlertContext';
/**
 *
 * @returns {[null, function, function]}
 */
const useAlerts = () => {
  const alertService = useContext(AlertContext);

  return [null, alertService.addSuccessAlert, alertService.addErrorAlert];
};


export default useAlerts;
